import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { BodyPrimary } from 'components/Typography'
import { ActiveConfigurationContainer } from '../ActiveConfiguration/styles'

export const StyledUpdatesButton = styled(CommonButton)`
  text-transform: capitalize;
  font-weight: 900;
  height: 40px;
  max-width: 210px;
  min-width: 180px;
  padding: 12px 12px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.pelicanGrey};
`
export const SoftwareVersionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 15px;
`

export const SoftwareVersionContainer = styled(ActiveConfigurationContainer)``

export const SoftwareVersionLabel = styled(BodyPrimary)``
